import { env } from "."

export const list = [
    {
        id: 1,
        title: 'Правила игры',
        text: 'Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера. Для игры используется одна стандартная колода из 52-х карт. Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта. За столом может играть только один игрок. Игрок может играть на один бокс или два бокса равными ставками. Если игрок, посмотрев свои карты, отказывается от игры, ставка Анте проигрывает. За сумму, равную ставке Анте, игрок может обменять от двух до пяти карт или докупить шестую карту. После этого игрок принимает решение – продолжать игру или нет. Если игрок принял решение играть, то он должен поставить ставку, равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты. Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков. У дилера есть игра, если в его картах есть комбинация Туз – Король или выше. Если у дилера нет игры – оплачивается только ставка Анте 1:1. Если у игрока комбинация старше, чем у дилера, оплачивается только ставка Бет в соответствии с таблицей выплат. Кроме выигрышной комбинации в картах игрока может быть образована вторая комбинация, которая также оплачивается. Вторая комбинация должна включать в себя хотя бы одну карту, не входящую в основную комбинацию. При комбинации Стрит оплачивается Стрит и Пара, а не два Стрита. Туз-Король и пара не является двумя парами. Если игровая комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.',
        content:
            <div className="content">
                <p>
                    Рулетка — простая и, в то же время, захватывающая игра. Игровой стол состоит из колеса с номерами от 0 до 36 и игрового поля, размеченного таким образом, что на нем указаны все возможные комбинации ставок. Схема, приведенная ниже, объясняет все возможные ставки, что поможет Вам быстро освоить игру. Для каждого вида ставок существует минимум и максимум, указанный на каждом столе.
                    <br /><br />
                    Дилер предлагает игрокам делать ставки и запускает шарик (делает спин). Если шарик покидает пределы колеса или делает меньше трех оборотов, или в колесо попадает посторонний предмет, дилер объявляет «нет спина» останавливает игру и все ставки аннулируется. После этого начинается новая игра.
                </p>

                <p>После падения шарика в одну из пронумерованных ячеек, дилер объявляет выигрышный номер и ставит на этот номер на игровом поле специальный маркер – «Долли». Поле очищается и производится выплата в установленном порядке в соответствии с таблицей выплат.</p>

                {env && env.type && env.type === "super-roulette" ? <p style={{ fontWeight: 500 }}>При выпадении ЗЕРО все ставки на дюжинах и колонках проигрывают. Ставки на равных шансах (1-18; 19-36; красные, черные, четные, нечетные) проигрывает 50 %.</p> : null}

                <br/>

                <img className='rule-img-big widget' src='/images/table.webp' alt="table" />

                <p><strong>Выплаты</strong></p>

                <table className="rule-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Комбинация</th>
                            <th>Выплата</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>STRAIGHTUP - на один номер</td>
                            <td>35:1</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>SPLIT - на два номера</td>
                            <td>17:1</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>STREET - на три номера</td>
                            <td>11:1</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>CORNER - на четыре номера</td>
                            <td>8:1</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>SIX LINE - на шесть номеров</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>COLUMN/DOZEN - на 12 номеров</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>CHANCE - ЧЕРНЫЙ/КРАСНЫЙ, ЧЕТ/НЕЧЕТ, БОЛЬШИЕ/МАЛЫЕ НОМЕРА</td>
                            <td>1:1</td>
                        </tr>
                    </tbody>
                </table>

            </div>
    },
    {
        id: 2,
        title: 'Трек',
        content:
            <div className="content">

                <p>ТРЕК — это дополнительное поле для ставок, номера на котором расположены в точно такой же последовательности, как пронумерованы ячейки на колесе рулетки</p>
                <img className='rule-img-big widget' src='/images/race.webp' alt="table" />

                <br />
                <p>На треке игрок может поставить ставки на номер и соседние номера, расположенные на колесе с двух сторон от выбранного номера. Игрок может выбрать количество соседних номеров с каждой стороны.</p>
                <p>Также игрок может поставить ставки на Сектор. Данная ставка позволяет игроку необходимым и минимальным количеством фишек перекрыть все номера, входящие в один из четырех секторов круга рулетки.</p>

                <p style={{ textTransform: 'uppercase' }}><strong>«Voisins du Zéro» (БОЛЬШАЯ СЕРИЯ)</strong></p>

                <p>17 номеров от 22 до 25 на колесе рулетки, 9 фишек.</p>

                <table className="rule-table" style={{ width: "60%" }}>
                    <thead>
                        <tr>
                            <th>Позиции</th>
                            <th>Фишки</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Street 0-2-3</td>
                            <td>2 фишки</td>
                        </tr>
                        <tr>
                            <td>Corner 25-26-28-29</td>
                            <td>2 фишки</td>
                        </tr>
                        <tr>
                            <td>Split 4–7</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 12–15</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 18–21</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 19–22</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 32–35</td>
                            <td>1 фишка</td>
                        </tr>
                    </tbody>
                </table>

                <br />

                <p style={{ textTransform: 'uppercase' }}><strong>«Tier» (МАЛАЯ СЕРИЯ)</strong></p>

                <p>12 номеров от 27 до 33 на колесе рулетки, 6 фишек.</p>

                <table className="rule-table" style={{ width: "60%" }}>
                    <thead>
                        <tr>
                            <th>Позиции</th>
                            <th>Фишки</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Split 5–8</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 10–11</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 13–16</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 23–24</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 27–30</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 33–36</td>
                            <td>1 фишка</td>
                        </tr>
                    </tbody>
                </table>

                <br />

                <p style={{ textTransform: 'uppercase' }}><strong>«Orphelins»</strong></p>

                <p>8 номеров от 17 до 6 и от 1 до 9 на колесе рулетки, 5 фишек.</p>

                <table className="rule-table" style={{ width: "60%" }}>
                    <thead>
                        <tr>
                            <th>Позиции</th>
                            <th>Фишки</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Straight up 1</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 6–9</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 14–17</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 17–20</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 31–34</td>
                            <td>1 фишка</td>
                        </tr>
                    </tbody>
                </table>

                <br />

                <p style={{ textTransform: 'uppercase' }}><strong>«zero-spiel»</strong></p>

                <p>7 номеров от 12 до 15 на колесе рулетки, 4 фишки.</p>

                <table className="rule-table" style={{ width: "60%" }}>
                    <thead>
                        <tr>
                            <th>Позиции</th>
                            <th>Фишки</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Straight up 26</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 0–3</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 12–15</td>
                            <td>1 фишка</td>
                        </tr>
                        <tr>
                            <td>Split 32–35</td>
                            <td>1 фишка</td>
                        </tr>
                    </tbody>
                </table>

            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="content">

                Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.
                <br /><br />
                Roulette 1 -  1 000 $
                <br /><br />
                Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.
                <br /><br />
                Ваши средства - БАЛАНС 100 000 $
                <br /><br />
                В иммерсивном виде ТАЙМЕР показывает оставшееся время для размещения ставок. По истечении этого времени ставки больше не принимаются.
                <br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/choiseTimer.png`} alt="bet-ante" />
                <br /><br />
                Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.png`} alt="chips" />
                <br /><br />
                ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.
                <br /><br />
                Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Вы сможете наблюдать за ходом игры, но не сможете в ней участвовать. Чтобы сделать новые ставки, вам придется дождаться следующего раунда.
                <br /><br />
            </div>
    },
    {
        id: 5,
        title: 'Чат',
        content:
            <div className="content">
                Вы можете обмениваться сообщениями с ведущим игры и другими игроками. Введите свое сообщение в окне ЧАТА. Для отправки сообщения нажмите Ввод или стрелочку, расположенную в поле.
                <br /><br />
                Для игроков, которые некорректно ведут себя в чате, оскорбляют ведущего и других игроков, используют неуместные и/или оскорбительные выражения, доступ к чату будет закрыт.
                <br /><br />
                Используйте кнопку «ЧАТ» для увеличения или закрытия окна чата.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/chat.svg`} alt="chips" />
            </div>
    },
    {
        id: 6,
        title: 'Номер игры',
        content:
            <div className="content">
                Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/game-number.svg`} alt="number" />
                <br /><br />
                Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.
            </div>
    },
    {
        id: 7,
        title: 'Звук',
        content:
            <div className="content">
                Кнопка «ЗВУК» включает/выключает все звуки игры и голоса.
                Примите к сведению, что в случае смены стола все звуки включатся автоматически.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/audio-on.svg`} alt="chips" />
                <br /><br />
                Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК,
            </div>
    },
    {
        id: 8,
        title: 'История игр',
        content:
            <div className="content">
                С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/history.svg`} alt="chips" />
                <br /><br />
                Вы можете просматривать свою игровую активность с помощью . следующего:
                <br /><br />
                • ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.
                <br /><br />
                Последний завершенный раунд отображается в самом верху списка.
                <br /><br />
                • ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.
            </div>
    },
    {
        id: 9,
        title: 'Действия в случае сбоя',
        content:
            <div className="content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 10,
        title: 'Политика отключения',
        content:
            <div className="content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]